import type { FilterComponentProps } from '@/app/common/filters/core/filterComponentType.ts';
import type { FilterDataOption, FilterDataRadio } from '@/app/common/filters/core/filtersTypes.ts';
import { FilterBadgeContent } from '@/app/common/filters/surfaces/badges/FilterBadgeContent.tsx';
import React from 'react';
import styled from 'styled-components';

const StandardLabel = (option: FilterDataOption): string => option.label;

const RadioOptions = styled.div``;

export const FilterRadioBadge = ({
  filter,
  customFilterLabelCreator,
  isLoading,
  handleFilterChanged,
}: FilterComponentProps) => {
  const filterData = filter.data as FilterDataRadio;

  const handleFilterClicked = (valueClicked: string) => {
    const optionsWithClickedOptionReset = filterData.options.map((option) =>
      option.value === valueClicked ? { ...option, selected: false } : option
    );
    const otherOptionSelected = optionsWithClickedOptionReset.find((option) => option.selected && !option.isDefault);
    const updatedOptions = optionsWithClickedOptionReset.map((option) =>
      option.isDefault && !otherOptionSelected ? { ...option, selected: true } : option
    );
    const updatedFilter = {
      ...filter,
      data: {
        ...filter.data,
        options: updatedOptions,
      },
    };
    handleFilterChanged([updatedFilter]);
  };

  const labelCreator = customFilterLabelCreator || StandardLabel;

  const options = filterData.options
    .filter((option) => option.selected)
    .filter((option) => !option.isDefault)
    .map((option) => (
      <FilterBadgeContent
        key={option.label}
        label={labelCreator(option)}
        handleFilterClicked={() => handleFilterClicked(option.value)}
        isLoading={isLoading}
      />
    ));

  return <RadioOptions>{options}</RadioOptions>;
};
